import {
  Component,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {Asset} from "../asset.model";
import {AssetRenderStyle} from '../asset-render-style';
import {AssetTileComponent} from './asset-tile/asset-tile.component';
import {FullHeighDirective} from '../../common/full-heigh.directive';
import {AssetListItemComponent} from './asset-list-item/asset-list-item.component';
import {AssetStateService} from '../asset.state.service';
import {Subscription} from 'rxjs';
import {AssetAction} from '../../dam-header/action-bar/asset-action';
import {MatFormField} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {OrderDirection} from '../order-direction';
import {OrderBy} from '../order-by';
import {AssetFilter} from '../asset-filter';
import {FormsModule} from '@angular/forms';
import {DOCUMENT, Location, NgClass} from '@angular/common';
import {AssetCount} from '../asset-count';
import {SelectAssetData} from './select-asset-data';
import {DrawSelectorDirective} from '../../common/draw-selector.directive';
import {HttpParams} from "@angular/common/http";
import {TranslatePipe} from "@ngx-translate/core";
import {MatTooltip} from "@angular/material/tooltip";
import {AssetService} from "../asset.service";
import {SnackBarService} from "../../common/snack-bar-service";
import {DownloadSnackbarData} from "../../common/download-snackbar/download-snackbar-data";
import {ConfirmData} from "../../common/confirm-data";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmComponent} from "../../common/confirme/confirm.component";

@Component({
  selector: 'app-asset-result',
    imports: [
        AssetTileComponent,
        FullHeighDirective,
        AssetListItemComponent,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatOption,
        MatSelect,
        FormsModule,
        DrawSelectorDirective,
        TranslatePipe,
        MatTooltip,
        NgClass,
        MatButton,
    ],
  templateUrl: './asset-result.component.html',
  styleUrl: './asset-result.component.scss'
})
export class AssetResultComponent implements OnInit, OnChanges, OnDestroy {
  protected readonly AssetRenderStyle = AssetRenderStyle;
  @Input() assets: Asset[] = [];
  assetCount:AssetCount | undefined;
  @Input({required: true}) totalItems: number = 0;
  @Input({required: true}) renderStyle: AssetRenderStyle | undefined;
  currentIndex: number = 0;
  assetActionSubscription: Subscription | undefined
  assetCountSubscription: Subscription | undefined;
  assetFilter: AssetFilter | undefined;
  filterSubscription: Subscription | undefined;
  blockedSubscription: Subscription | undefined;
  selectedAssets: Asset[] = [];
  multiSelectMode  = false;
  isTestServer: boolean = false;
  bytesPerSecond = 28 * 1024 * 1024; // 28mb/s
  bytesTotalDownload: number = 0;
  blocked: boolean = true;
  preventDeselection = false;
  constructor(private assetStateService: AssetStateService,
              private location: Location,
              private assetService: AssetService,
              @Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private snackbarService: SnackBarService,
              private dialog: MatDialog) {
  }
  @HostListener('window: keydown.shift', ['$event'])
  handleShiftDown(event: KeyboardEvent) {
    this.multiSelectMode = true;
    // console.log('multiSelect?', this.multiSelectMode);
  }
  @HostListener('window: keyUp.shift', ['$event'])
  handleShiftUp(event: KeyboardEvent) {
    this.multiSelectMode = false;
  }
  stopPropagation(e: MouseEvent) {
    if (e) {
      e.stopPropagation();
    }
  }
  clearSelectedAssets() {
    this.assetStateService.assetAction = AssetAction.selectNone;
  }
  deselect() {
    if (this.selectedAssets && this.selectedAssets.length > 0) {
      for (const asset of this.assets) {
        asset.selected = false;
      }
      this.selectedAssets = [];
      this.assetStateService.assetSelection = this.selectedAssets;
      this.updateAsstCount()
    }
  }
  ngOnInit() {
    this.isTestServer = this.checkIsTestServer()
    this.assetActionSubscription = this.assetStateService.assetAction$.subscribe(assetAction => {
      if (assetAction) {
        if (assetAction === AssetAction.nextAsset) {
          this.nextAsset()
        }
        if (assetAction === AssetAction.prevAsset) {
          this.prevAsset();
        }
        if (assetAction === AssetAction.selectNone) {
          this.deselect();
        }
        if (assetAction === AssetAction.downloadAssets) {
          this.prepareDownLoadAssets();
        }
        if (assetAction === AssetAction.downloadAllAssets) {
          this.prepareDownLoadAllAssets();
        }
        if (assetAction === AssetAction.deleteAssets) {
          this.deleteAssets()
        }
        if(assetAction === AssetAction.reloadAssets) {
          this.reloadAssets()
        }
      }
    })
    this.filterSubscription = this.assetStateService.filter$.subscribe(filter  => {
      this.assetFilter = filter;
    })
    this.blockedSubscription = this.assetStateService.filterBlocked$.subscribe(blocked => {
      this.blocked = blocked;
    })
    this.assetCountSubscription = this.assetStateService.assetCount$.subscribe(result => {
      if (result) {
        this.assetCount = result;
      }
    })
  }
  checkIsTestServer(): boolean {
    const domain = document.location.host;
    let i: number = domain.indexOf('local');
      if (i !== -1) {
        return true;
      }
      let k: number = domain.indexOf('test');
      return k !== -1;

  }
  ngOnChanges(changes: SimpleChanges) {
   // console.log('changes', changes);
    if (changes['totalItems']) {
      this.updateAsstCount();
    }
    if (changes['assets']) {
      if (!this.preventDeselection) {
        this.deselect();
      }
     this.preventDeselection = false;
    }
   /* if (changes['totalItems']) {
      this.loadNext()
    }*/
  }
  reloadAssets() {
    if (this.assetFilter) {
      this.assetStateService.loadNextPageAssets(this.assetFilter);
    }
  }
  prepareDownLoadAssets() {
    if (this.selectedAssets && this.selectedAssets.length > 1) {
      const assetUuids: string[] = [];
      let bytesTotal: number = 0;
      for (const as of this.selectedAssets) {
        assetUuids.push(as.uuid)
        bytesTotal += as.assetBinary.fileSize;
      }
      this.bytesTotalDownload = bytesTotal
      if (this.assetFilter) {
        this.assetService.prepareDownloadAssets(assetUuids, this.getParamForAsset(this.assetFilter)).subscribe(res => {
          if (res && res.data && res.data.uuid) {
            const data: DownloadSnackbarData = {
              progress: this.calculateProgress(0),
              status: 'polling',
              isComplete: false,
              message: 'PREPARING',
              bytesTotal: this.bytesTotalDownload
            }
            this.snackbarService.setDownloadSnackbarData(data);
            this.snackbarService.showDownloadSnackbar();
            this.pollDownloads(res.data.uuid, 0);
          }
        })
      }
    } else {
      if (this.selectedAssets && this.selectedAssets.length === 1) {
        this.downloadSingleFile(this.selectedAssets[0].uuid);
      }
    }

  }
  prepareDownLoadAllAssets() {
    const assetUuids: string[] = [];
    let bytesTotal: number = 0;
    for (const as of this.assets) {
      assetUuids.push(as.uuid)
      bytesTotal += as.assetBinary.fileSize;
    }
    this.bytesTotalDownload = bytesTotal
    if (this.assetFilter) {
      this.assetService.prepareDownloadAssets(assetUuids, this.getParamForAsset(this.assetFilter)).subscribe(res => {
        if (res && res.data && res.data.uuid) {
          const data: DownloadSnackbarData = {
            progress: this.calculateProgress(0),
            status: 'polling',
            isComplete: false,
            message: 'PREPARING',
            bytesTotal: this.bytesTotalDownload
          }
          this.snackbarService.setDownloadSnackbarData(data);
          this.snackbarService.showDownloadSnackbar();
          /*this.snackbarService.showMessage({
            message: 'preparing.download',
            success:true,
            action: 'wait'
          })*/
          this.pollDownloads(res.data.uuid, 0);
        }
      })
    }
  }
  pollDownloads(id: string, counter: number) {
    this.assetService.pollDownload(id).subscribe(res => {
      if (!res.data.isComplete ){
        const data: DownloadSnackbarData = {
          progress: this.calculateProgress(counter),
          status: 'polling',
          isComplete: false,
          message: 'DOWNLOAD.PREPARING',
          bytesTotal: this.bytesTotalDownload
        }
        this.snackbarService.setDownloadSnackbarData(data);
        setTimeout(() => {
          counter ++;
          this.pollDownloads(id, counter);
        }, 3000)
      } else {
        const data: DownloadSnackbarData = {
          progress: this.calculateProgress(counter),
          status: 'ready',
          link: res.data.url,
          fileName: res.data.filename,
          message: 'DOWNLOAD.READY',
          isComplete: true,
          bytesTotal: this.bytesTotalDownload
        }
        this.snackbarService.setDownloadSnackbarData(data);
        //this.doDownload(res.data.url, res.data.filename)
      }
    })
  }
  calculateProgress(counter: number): number {
    const w = (counter * 3) * this.bytesPerSecond;
   // console.log('w', w, ' of total ', this.bytesTotalDownload);
    const perz = (w * 100) / this.bytesTotalDownload;
   // console.log('perz', perz, ' of total ', this.bytesTotalDownload);
    if (perz < 100) {
      return perz;
    }
    return 93.92;

  }
  downloadSingleFile(id: string) {
    if (this.assetFilter) {
      const params: HttpParams | undefined = this.getParamForAsset(this.assetFilter);
      this.assetService.downloadAsset(id, params).subscribe(  res => {
        if (res && res.data) {
          const link = this.renderer.createElement('a');
          link.setAttribute('target', '_blank');
          link.setAttribute('href', res.data.url);
          link.setAttribute('download', res.data.filename);
          link.click();
          link.remove();
          this.deselect();
        }
      })

    }
  }

  deleteAssets() {
    if (this.selectedAssets && this.selectedAssets.length > 0) {
        const mess: ConfirmData = {
          headline: "Delete.assets.hl",
          mess1: 'Delete.assets.mess1',
          mess2: '',
          mess3: '',
          btnText: 'button.deleteAssets',
        }
       const ref = this.dialog.open(ConfirmComponent, {
         data: mess,
         width: '800px',
         autoFocus: false,
       });
        ref.afterClosed().subscribe(result => {
          if (result) {
            this.doDeleteAssets();
          }
        })
    }
  }
  doDeleteAssets() {
    if (this.selectedAssets && this.selectedAssets.length > 0) {
      const uuids: string[] = [];
      for (const asset of this.selectedAssets) {
        uuids.push(asset.uuid);
      }
      this.deselect();
      this.assetService.deleteAssets(uuids).subscribe(() => {
        this.reloadAssets();
      })
    }
  }
  doDownload(url: string, fileName: string) {
    this.snackbarService.hideMessage();
    const link = this.renderer.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href',url);
    link.setAttribute('download', fileName);
    link.click();
    link.remove();
    this.deselect();
  }
  getParamForAsset(assetFilter: AssetFilter): HttpParams | undefined {
    let params = new HttpParams();
    if (assetFilter.collectionUuid) {
      params = params.set('collectionUuid', assetFilter.collectionUuid);
      return params;
    }
    if (assetFilter.collectionSharedUuid) {
      params = params.set('collectionSharedKey', assetFilter.collectionSharedUuid);
      return params;
    }
    if (assetFilter.collectionPublicUuid) {
      params = params.set('collectionPublicSlug', assetFilter.collectionPublicUuid);
      return params;
    }
    return undefined;
  }

  updateFilter() {
    if (this.assetFilter) {
      this.assetFilter.page = 1;
     // this.assetStateService.filter = this.assetFilter;
      this.assetStateService.loadNextPageAssets(this.assetFilter);
    }
  }
  toggleSortOrder() {
    if (this.assetFilter) {
      if (this.assetFilter.order === OrderDirection.desc) {
        this.assetFilter.order = OrderDirection.asc;
      } else {
        this.assetFilter.order = OrderDirection.desc;
      }
      this.assetFilter.page = 1;
      this.assetStateService.loadNextPageAssets(this.assetFilter);
     // this.assetStateService.filter = this.assetFilter;
    }
  }
  toggleView(renderStyle: AssetRenderStyle) {
    this.renderStyle = renderStyle;
  }

  onItemLoaded(index:number): void {
    if (index === this.assets.length - 10) {
     // this.nextPage.emit(true);
      this.loadNext();

    }
  }
  loadNext() {
    if (this.assetFilter) {
      if (this.assets && this.assets.length < this.totalItems) {
       // console.log(this.assets.length, this.totalItems);
        this.assetFilter.page += 1;
        this.assetFilter.resultsPerPage = 300;
       // this.assetStateService.filter = this.assetFilter;
        this.preventDeselection = true;
        this.assetStateService.loadNextPageAssets(this.assetFilter);
      }
    }
  }
  nextAsset() {
    //console.log('currentIndex?', this.currentIndex)
    this.showAssetDetails((this.currentIndex + 1))
  }
  prevAsset() {
    this.showAssetDetails((this.currentIndex - 1));
  }
  assetStatusChanged(data: SelectAssetData) {
   // console.log('asset status', data);
    if (data.asset.selected) {
      if (!this.multiSelectMode) {
        this.selectAsset(data.asset);
      } else {
        this.checkSelectMultipleAssets(data);
      }

    } else {
      this.removeAsset(data.asset);
    }
  }
  checkSelectMultipleAssets(data: SelectAssetData) {
    if (this.selectedAssets && this.selectedAssets.length > 0) {
      const firstIndex = this.assets.indexOf(this.selectedAssets[0]);
      if (firstIndex !== -1) {
        let startIndex: number;
        let endIndex: number;
        if (firstIndex <= data.index) {
          startIndex = firstIndex;
          endIndex = data.index;
        } else {
          startIndex = data.index -1;
          endIndex = firstIndex-1;
        }
       // console.log('startIndex', startIndex, 'endIndex', endIndex);
        for (let i = startIndex + 1; i <= endIndex; i++) {
          this.assets[i].selected = true;
          this.selectedAssets.push(this.assets[i]);
        }
        this.assetStateService.assetSelection = this.selectedAssets;
      /* for ( const ass of this.selectedAssets ) {
          console.log('ass selected', ass.title);
        }*/
        this.updateAsstCount();
      }

    }
  }
  selectAsset(asset: Asset) {
    // console.log('adding asset?', asset);
    this.selectedAssets.push(asset);
   // console.log('selected asset', this.selectedAssets);
    this.assetStateService.assetSelection = this.selectedAssets;
    this.updateAsstCount();
  }
  removeAsset(asset: Asset) {
    const index = this.selectedAssets.indexOf(asset);
    if (index > -1) {
      this.selectedAssets.splice(index, 1);
      this.assetStateService.assetSelection = this.selectedAssets
    }
    this.updateAsstCount();
  }
  showAssetDetails(index: number): void {
    if (this.assets) {
      const id = this.assets[index].uuid;
      const params = new HttpParams().append(
          'assetId', id
      );
      this.location.replaceState(
          location.pathname, params.toString()
      )
      this.assetStateService.assetUuidFromQueryParam = id;
    }
  }
  updateAsstCount() {
    if (this.assetCount) {
      this.assetCount.assetsTotal = this.totalItems;
      this.assetCount.assetsVisible = this.assets.length;
      this.assetCount.assetsSelected = this.selectedAssets.length;
     // console.log('updating assets:', this.assets.length);
      this.assetStateService.assetCount = this.assetCount;
    }
  }
  reloadApp() {
    window.location.reload();
  }

  ngOnDestroy() {
    if(this.assetActionSubscription) {
      this.assetActionSubscription.unsubscribe();
    }
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
    if (this.assetCountSubscription) {
      this.assetCountSubscription.unsubscribe();
    }
    if (this.blockedSubscription) {
      this.blockedSubscription.unsubscribe();
    }
  }


  protected readonly OrderDirection = OrderDirection;
  protected readonly OrderBy = OrderBy;
}
